import { render, staticRenderFns } from "./copy-staff.vue?vue&type=template&id=422f1034&scoped=true&"
import script from "./copy-staff.vue?vue&type=script&lang=js&"
export * from "./copy-staff.vue?vue&type=script&lang=js&"
import style0 from "./copy-staff.vue?vue&type=style&index=0&id=422f1034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f1034",
  null
  
)

export default component.exports